import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLink } from '@grandvisionhq/frk-routing';
import { useIsGooglePaySupportedForCart } from '../../../hooks/use-is-google-pay-supported-for-cart.js';
import '../../../models/adyen/payment-type.js';
import { ExpressPaymentMethod, PaymentMethod } from '../../../models/cart-payment-methods/cart-payment-methods.js';
import '../../../models/googlePay/types.js';
import '../../../models/payment/types.js';
import '../../../models/paypal/context.js';
import { GooglePayButton } from './GooglePayExpressCheckoutButton.js';

const GooglePayExpressCheckoutButtonContainer = ({ cartId , cartHash , onClickHandler  })=>{
    const cartLink = useLink({
        route: 'cart.overview'
    });
    const expressCheckoutLink = useLink({
        route: 'express-checkout',
        params: swcHelpers.objectSpread({
            type: ExpressPaymentMethod.GOOGLE_PAY,
            returnPath: cartLink === null || cartLink === void 0 ? void 0 : cartLink.href,
            cartId
        }, cartHash ? {
            cartHash
        } : null)
    });
    const handleOnClick = React.useCallback(()=>{
        onClickHandler && onClickHandler(PaymentMethod.GOOGLE_PAY);
        expressCheckoutLink === null || expressCheckoutLink === void 0 ? void 0 : expressCheckoutLink.onClick();
    }, [
        expressCheckoutLink,
        onClickHandler
    ]);
    const { isGooglePaySupportedForCart , called , loading  } = useIsGooglePaySupportedForCart(cartId);
    if (!isGooglePaySupportedForCart || !called || loading) {
        return null;
    }
    if (!expressCheckoutLink) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(GooglePayButton, {
        onClick: handleOnClick
    });
};

export { GooglePayExpressCheckoutButtonContainer };
//# sourceMappingURL=GooglePayExpressCheckoutButtonContainer.js.map
